import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorMessage: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, info) {
        console.error('[ErrorBoundary] Error capturado:', error, info);
        this.setState({ errorMessage: error?.message || String(error) });
    }

    handleRetry = () => {
        this.setState({ hasError: false, error: null });
    };

    render() {
        if (this.state.hasError) {
            return (
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '100vh',
                    padding: '2rem',
                    textAlign: 'center',
                    backgroundColor: 'var(--ev-bg-canvas)',
                }}>
                    <h2 style={{ color: '#dc3545', marginBottom: '1rem' }}>
                        Algo salió mal
                    </h2>
                    <p style={{ color: '#6c757d', marginBottom: '1.5rem', maxWidth: '400px' }}>
                        Ocurrió un error inesperado. Por favor intenta de nuevo o recarga la página.
                    </p>
                    {this.state.errorMessage && (
                        <p style={{ color: '#999', fontSize: '0.75rem', marginBottom: '1.5rem', maxWidth: '400px', wordBreak: 'break-all', fontFamily: 'monospace' }}>
                            {this.state.errorMessage}
                        </p>
                    )}
                    <div style={{ display: 'flex', gap: '1rem' }}>
                        <button
                            onClick={this.handleRetry}
                            style={{
                                padding: '0.5rem 1.5rem',
                                backgroundColor: 'var(--ev-action-primary-bg)',
                                color: 'var(--ev-action-primary-fg)',
                                border: 'none',
                                borderRadius: '0.375rem',
                                cursor: 'pointer',
                                fontSize: '1rem',
                            }}
                        >
                            Reintentar
                        </button>
                        <button
                            onClick={() => window.location.reload()}
                            style={{
                                padding: '0.5rem 1.5rem',
                                backgroundColor: '#6c757d',
                                color: 'var(--ev-action-primary-fg)',
                                border: 'none',
                                borderRadius: '0.375rem',
                                cursor: 'pointer',
                                fontSize: '1rem',
                            }}
                        >
                            Recargar página
                        </button>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
